import React from 'react';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './chatSuggestions.module.scss';

export const suggestions = [
    {
        id: 'landing.pages.chat.suggestions.author',
        defaultText: 'Change the author name',
    },
    {
        id: 'landing.pages.chat.suggestions.sticky.cta',
        defaultText: 'Add a sticky CTA button',
    },
    {
        id: 'landing.pages.chat.suggestions.testimonial',
        defaultText: 'Add a testimonial',
    },
    {
        id: 'landing.pages.chat.suggestions.main.image',
        defaultText: 'Re-generate the main image',
    },
    {
        id: 'landing.pages.chat.suggestions.headline',
        defaultText: "Let's use a different headline",
    },
    {
        id: 'landing.pages.chat.suggestions.revert.last',
        defaultText: 'Revert the last change',
    },
    {
        id: 'landing.pages.chat.suggestions.faq.accordion',
        defaultText: 'Add an accordion styled FAQ element',
    },
    {
        id: 'landing.pages.chat.suggestions.comparison',
        defaultText: 'Add a comparison table',
    },
];

export const ChatSuggestions = ({ visibleSuggestions, showSuggestions, onSuggestionClick, onToggleSuggestions }) =>
    showSuggestions ? (
        <div className={styles['container']}>
            <div className={styles.suggestions}>
                {visibleSuggestions.map(suggestion => (
                    <button
                        key={suggestion.id}
                        className={styles['bubble']}
                        onClick={() => onSuggestionClick(suggestion)}
                    >
                        <FormattedMessage id={suggestion.id} defaultMessage={suggestion.defaultText} />
                    </button>
                ))}
            </div>
            <button className={styles['button']} onClick={onToggleSuggestions}>
                <FormattedMessage id="landing.pages.chat.suggestions.hide" defaultMessage="Hide suggestions" />
            </button>
        </div>
    ) : (
        <button className={styles['button']} onClick={onToggleSuggestions}>
            <FormattedMessage id="landing.pages.chat.suggestions.show" defaultMessage="Show suggestions" />
        </button>
    );
